import { render } from "./headerpos.vue?vue&type=template&id=7f6ebc32"
import script from "./headerpos.vue?vue&type=script&lang=js"
export * from "./headerpos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__